import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class FerryService {
  static getferry(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.getferryservice}?id=${item?.id}`
      } else{
      api = `${API_BASE_URL}${API_PATHS.getferryservice}?limit=${item?.limit}&page=${item?.page}`;
      }
      return axiosInstance
          .get(api)
          
  }

  
static addferry(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addferryservice}`;
    return axiosInstance
        .post(api,item)
        
}
static editferry(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editferryservice}`;
    return axiosInstance
        .put(api,item)
        
}
static deleteferry(item) {
  
    let api = '';
    if(item?.id){
        api = `${API_BASE_URL}${API_PATHS.deleteferryservice}?id=${item?.id}`;
    }else{
        api = `${API_BASE_URL}${API_PATHS.deleteferryservice}`;
    }
    
    return axiosInstance
        .delete(api)
        
}


  
}

export default FerryService;